export default __webpack_public_path__ + "static/media/chemist.52f3622d.jpg";